import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { ReactComponent as IconTik } from '@assets/icons/crm/Tik.svg';

import { toastError } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

import { BASE_URL } from '@/constants/constant';

const AssignMember = ({ selectedType, closeModal, callback, existingUsers, removeMember }) => {
	const [userList, setUserList] = useState([]);
	const dispatch = useDispatch();
	const teamRef = useRef();
	const { id } = useParams();

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleClickOutside = (event) => {
		if (teamRef && !teamRef.current.contains(event.target)) {
			closeModal();
		}
	};

	const findUsersByType = async (search) => {
		try {
			dispatch(openLoader());
			const params = {
				userTypeList:
					selectedType === 'ACCOUNT_MANAGER' ? `ACCOUNT_MANAGER,PROJECT_MANAGER` : selectedType
			};
			if (search) {
				params.search = search;
			}
			const { data } = await ApiClient.GET('userSearch', params);
			dispatch(closeLoader());
			setUserList(data.data);
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};

	useEffect(() => {
		findUsersByType();
	}, []);

	const addMember = async (userId) => {
		try {
			dispatch(openLoader());
			let postData = {
				userId,
				userType: selectedType
			};
			await ApiClient.POST(`${BASE_URL}/brand/${id}/members`, postData, '', true);
			if (callback) {
				callback();
			} else {
				dispatch(closeLoader());
			}
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};

	const renderTikSign = (personId) => {
		const selectedUser = existingUsers?.find((item) => item.id === personId);
		if (selectedUser) {
			return (
				<span>
					<IconTik />
				</span>
			);
		}
	};

	const handleUserClick = async (personId) => {
		const selectedUser = existingUsers?.find((item) => item.id === personId);
		if (selectedUser) {
			await removeMember(personId);
		} else {
			if (selectedType === 'ACCOUNT_MANAGER' && existingUsers?.length > 0) {
				toastError('Account manager already exist!');
				return;
			}
			await addMember(personId);
		}
	};

	return (
		<div className="assign-member shadow open" ref={teamRef}>
			<div className="title d-flex justify-content-between">
				<p className="semibold-16">Assign member</p>
				<img
					src={`${process.env.PUBLIC_URL}/icons/close.svg`}
					alt="close"
					className="cursor-pointer"
					onClick={closeModal}
				/>
			</div>
			<div className="member-list-container pt-0 scroll-y-label">
				<div className="search-filter bg-white">
					<div className="with-icon right-icon">
						<input
							type="text"
							autoComplete="off"
							placeholder="Search with email or name"
							onChange={(e) => findUsersByType(e.target.value)}
						/>
						<span className="right-icon">
							<img src={`${process.env.PUBLIC_URL}/icons/search.png`} alt="search" />
						</span>
					</div>
				</div>
				<div>
					{userList?.map((person, index) => (
						<div
							key={`member_list_${index}`}
							className={'member-list justify-content-between'}
							onClick={() => handleUserClick(person.id)}
							tabIndex={0}
						>
							<div className="d-flex align-items-center">
								{person?.profilePicDocument?.docUrl ? (
									<img src={person?.profilePicDocument?.docUrl} alt="profile" />
								) : (
									<img
										src={`${process.env.PUBLIC_URL}/images/pro_pic_default.svg`}
										alt="profile"
									/>
								)}
								<div className="name">{person.name}</div>
							</div>

							{renderTikSign(person.id)}
						</div>
					))}
					{userList.length === 0 && (
						<div className="empty-state">
							<p className="regular-14 gray_dark_02 mt-3">No member found!</p>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default AssignMember;
